//                                                           //
//  Program: ResidentPayoutsReports.jsx                              //
//  Application: Report                                      //
//  Option: Property Reports Listing                         //
//  Developer: NP 		                                     //
//  Date: 2022-08-30                                         //
//                                                           //
/////////////////////////////////////////////////////////   ///

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Tab, Modal, InputGroup, Form } from "react-bootstrap";
import PayoutSidebar from "../common/PayoutSidebar";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import ReportService from "../../services/ReportService";
import Select from "react-select";
import UnitsService from "../../services/UnitsService";
import StripePayoutService from "../../services/StripePayoutService";
import Moment from "moment";
import MultiImageService from "./../../services/MultiImageService";
import OutSidePropertySelectBox from "../outside-modules/OutSidePropertySelectBox";
import AllPropertyPayoutSidebar from "../common/AllPropertyPayoutSidebar";

class StripeTotalPayout extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.payoutDateInputGroupRef = React.createRef();
    this.state = {
      payoutDatePlacement: "bottom-start",
      errors: {},
      importModal: false,
      file_url: "",
      file_name: "",
      open: true,
      eventKey: "0",
      is_inactive: false,
      isSubmit: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      module_search: "",
      module_search_display: "",
      exportMesssage: "",
      exportFilePath: "",
      exportResult: "",
      alertType: "xlsx",
      is_search: 0,
      isSearch: global.isSearch,
      is_total: false,
      is_pay_out_modal: false,
      input: {},
      unitList: [],
      amount: "",
      search_description: "",
      destination: "",
      selectedUnitList: [],
      selectedStatusList: [],
      selectedPaymentStatusList: [],
      selectedTypeList: [],
      newTypeList: [
        { key: 1, value: 1, label: "Resident" },
        { key: 2, value: 2, label: "Property" },
      ],
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      totalPayOutList: {},
      deleteRoleModal: false,
      pay_status_slug: "",
      pay_status_lable: "",
      property_slug: this.props.match.params.propertySlug,
      batch_slug: this.props.match.params.batchSlug,
      type: this.props.match.params.type
        ? this.props.match.params.type
        : undefined,
      pathname: window.location.pathname,
      property_logo_url: sessionStorage.getItem("property_logo_url"),
      property_type: sessionStorage.getItem("property_type"),
      property_name: sessionStorage.getItem("property_name"),
      year_value: sessionStorage.getItem("year_value")
        ? sessionStorage.getItem("year_value")
        : "",
      records: [],
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: true,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      configPay: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: true,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      newUnitList: [],
      statusList: [],
      paymentStatusList: [],
      payMethodList: [],
      extraButtons: [],
      columns: [
        {
          key: "unit_full_name",
          sortable: true,
          text: "Property/Unit",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.unit_full_name;
          },
        },
        {
          key: "payable_name",
          /* sortable: true, */
          text: "Payable To",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payable_name;
          },
        },
        {
          key: "payout_total_payouts",
          sortable: true,
          text: "Amount",
          className: "report_id hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.total_bill ? "$" + record.total_bill : "$0";
          },
        },
        {
          key: "destination",
          sortable: true,
          text: "Destination",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.destination;
          },
        },
        {
          key: "description",
          sortable: true,
          text: "Description",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.description;
          },
        },
        {
          key: "payout_date",
          text: "Date",
          sortable: true,
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.payout_date
              ? Moment(record.payout_date).format("MM/DD/YY")
              : "";
          },
        },
      ],
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.getTotalBill = this.getTotalBill.bind(this);
    this.getData = this.getData.bind(this);
    this.getstripepayout = this.getstripepayout.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.propertySlug !== undefined) {
      this.getstripepayout();
    }
  }

  getPropertySlug(property_slug) {
    this.setState({ property_slug: property_slug });
    setTimeout(() => {
      this.getstripepayout();
    }, 200);
    this.setState({
      selectedUnitList: [],
      module_search: [],
      is_search: 0,
    });
  }

  async clearFilter() {
    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.setState({ is_search: 0 });
    this.setState({
      payout_date: "",
      search_description: "",
      destination: "",
      amount: "",
      checkout_date_to: lastDay,
      payout_duration_start_date: "",
      payout_duration_end_date: "",
      unit_slug: "",
      selectedUnitList: [],
      selectedStatusList: [],
      selectedPaymentStatusList: [],
      selectedMethodList: [],
      status_slug: "",
      unit_lable: "",
      type_lable: "",
      status_lable: "",
      method_lable: "",
    });
    this.setState({
      module_search: "",
      statusList: "",
      moduleList: "",
      paymentStatusList: "",
    });
    this.getstripepayout();
  }

  async ExportData() {
    this.setState({ showSpinner: true, isSubmit: true });
    let data = {
      property_slug: this.state.property_slug,
    };

    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let payoutDurationStartDate = this.state.payout_duration_start_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationEndDate = this.state.payout_duration_end_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let queryString =
      "is_export=1" +
      "&file_type=" +
      this.state.alertType +
      "&checkout_date_from=" +
      checkOutFromDate +
      "&unit_slug=" +
      (this.state.unit_slug ? this.state.unit_slug : "") +
      "&payout_duration_start_date=" +
      payoutDurationStartDate +
      "&payout_duration_end_date=" +
      payoutDurationEndDate;

    let res = await ReportService.exportResidentPayOutReport(data, queryString);
    if (res.data.filePath) {
      this.getDownloadFile(res.data.filePath, res.data.fileName);
      this.setState({ exportMesssage: res.message });
      this.setState({ exportResult: data });
      this.setState({ exportFilePath: res.data.filePath });
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  async getDownloadFile(url, name) {
    let file_name = name.split(".")[0];
    var queryString = "path=" + url + "&display_file_name=" + file_name;
    this.setState({ showSpinner: true, loading: true });
    let inputData = {
      // path: url,
    };
    var resData = {};
    await MultiImageService.downloadFile(inputData, queryString);
    this.setState(resData);
    this.setState({
      showSpinner: false,
      loading: false,
    });
  }

  exportToggle = () => {
    if (this.state.isModel === 1) {
      this.setState({ exportMesssage: "" });
      this.setState({ isModel: 0 });
      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      this.setState({ isModel: 1 });
    }
  };

  gerDefaultInOutDate() {
    this.setState({ payout_date: "" });
    this.setState({ payoutDurationEndDate: "" });
  }

  changeExport(evt) {
    let value = evt.target.value;
    this.setState({ alertType: value });
  }

  async showPayoutReport(unitSlug) {
    this.setState({ showSpinner: true, loading: true });
    var listPay = [];
    var totalRecordsPay = 0;
    let payoutDetailsTitle;
    let data = {
      property_slug: this.state.property_slug,
    };
    let payoutDate = this.state.payout_date
      ? Moment(this.state.payout_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationDateStart = this.state.payout_duration_start_date
      ? Moment(this.state.payout_duration_start_date).format("YYYY-MM-DD")
      : "";
    let payoutDurationDateTo = this.state.payout_duration_end_date
      ? Moment(this.state.payout_duration_end_date).format("YYYY-MM-DD")
      : "";
    let queryString =
      "unit_slug=" +
      unitSlug +
      "&payout_date=" +
      payoutDate +
      "&payout_duration_start_date=" +
      payoutDurationDateStart +
      "&payout_duration_end_date=" +
      payoutDurationDateTo;
    let res = await ReportService.showPayOutReport(data, queryString);
    if (global.successStatus.includes(res.status)) {
      listPay = res.data.data ? res.data.data : [];
      totalRecordsPay = res.data.data.length ? res.data.data.length : 0;
      payoutDetailsTitle = res.data.data.length
        ? res.data.data[0].aka_name + "-" + res.data.data[0].unit_number
        : "Pay Out Report";
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record_pay: totalRecordsPay,
      record_pay: listPay,
      payoutDetailsTitle: payoutDetailsTitle,
    });
    this.payoutDataModalToggle();
  }

  payoutDataModalToggle = () => {
    if (this.state.is_pay_out_modal === 1) {
      this.setState({ is_pay_out_modal: 0 });
    } else {
      this.setState({ is_pay_out_modal: 1 });
    }
  };

  getPayOutReports = async (queryString = "") => {
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var totalRecords = 0;
    let totalBill = 0;
    let res = await ReportService.getResidentPayOutReportsList(
      this.state.property_slug && this.state.property_slug !== undefined
        ? this.state.property_slug
        : "",
      queryString
    );
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
      totalRecords = res.data ? res.data.total : 0;
      totalBill = res ? res.other_data : 0;
      list = res ? res.data : 0;
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      // records: list,
      list: list,
      totalBill: totalBill,
    });
  };

  async getData() {
    this.setState({ showSpinner: true, loading: true });
    var Stripebalance = 100;

    this.setState({
      showSpinner: false,
      loading: false,
      Stripebalance: Stripebalance,
    });
  }

  async getstripepayout(queryString = "") {
    var list = [];
    var totalRecords = 0;
    this.setState({ showSpinner: true, loading: true });
    if (this.state.batch_slug !== undefined) {
      var queryString1 = "batch_slug=" + this.state.batch_slug;
    }
    var queryString2 =
      this.state.type && this.state.type === "property"
        ? "type_slug=2"
        : this.state.type && this.state.type === "resident"
        ? "type_slug=1"
        : "";
    let res = await StripePayoutService.gettotalpayout(
      this.state.property_slug && this.state.property_slug !== undefined
        ? this.state.property_slug
        : "",
      queryString
        ? queryString + (this.state.batch_slug ? queryString1 : "")
        : this.state.batch_slug
        ? queryString1 + (queryString2 ? "&" + queryString2 : "")
        : queryString2
        ? queryString2
        : ""
    );
    if (global.successStatus.includes(res.status)) {
      list = res.data.data ? res.data.data : [];
      totalRecords = res.data ? res.data.total : 0;
    }

    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      records: list,
    });
  }

  paymentpayout = async () => {
    let inputData = {
      result: this.state.list,
      other_data: this.state.totalBill,
    };
    let res = await StripePayoutService.payouttotalbill(inputData);
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      window.location.reload();
    }
    this.totalbill();
  };

  onChangeSearchDescription = (event) => {
    this.setState({ search_description: event.target.value });
  };

  onChangeSearchDestination = (event) => {
    this.setState({ destination: event.target.value });
  };

  onChangeSearchAmount = (event) => {
    this.setState({ amount: event.target.value });
  };

  /* to get unit data list */
  async getUnitData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var unitList = [];
    var unitListTotal = 0;
    let res = await UnitsService.getUnitsList(
      "is_dropdown=1&property_slug=" +
        (this.state.property_slug && this.state.property_slug !== undefined
          ? this.state.property_slug
          : ""),
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      unitList = res.data ? res.data : [];
      unitListTotal = unitList ? unitList.length : 0;
    }
    const newUnitList =
      unitListTotal > 0
        ? unitList.map(({ slug, unit_name, tower, total_tower_count }) => ({
            value: slug,
            label: unit_name,
          }))
        : [];
    this.setState({
      unitList: unitList,
      unitListTotal: unitListTotal,
      newUnitList: newUnitList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  // stripe

  async getTotalBill() {
    var totalBill = 0;
    let res = await StripePayoutService.gettotalpayment();

    if (global.successStatus.includes(res.status)) {
      totalBill = res.other_data.final_total_payout
        ? res.other_data.final_total_payout
        : 0;
    }

    this.setState({ totalBill: totalBill });
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
    }
  };

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.getUnitData();
      this.setState({ isSearch: 1 });
      const statusList = [
        { value: "pending", label: "Pending" },
        { value: "success", label: "Success" },
        { value: "fail", label: "Fail" },
      ];
      this.setState({ statusList: statusList });
    }
  };

  totalbill = () => {
    if (this.state.is_total === true) {
      this.setState({ is_total: false });
    } else {
      this.setState({ is_total: true });
    }
  };

  handleChangeUnitList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedUnitList: value,
      unit_slug: unit_slug_value,
      unit_lable: selected_unit_number,
    });
    this.setState({ confirm_back: 1 });
  }

  handleChangeTypeList(value) {
    let type_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        type_slug.push(item.value);
      });
    }
    const type_slug_value = value !== null ? value.value : [];
    const type_label_value = value !== null ? value.label : [];
    this.setState({
      selectedTypeList: value,
      type_slug: type_slug_value,
      type_label: type_label_value,
    });
    this.setState({ confirm_back: 1 });
  }

  handleChangeStatusList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedStatusList: value,
      status_slug: unit_slug_value,
      status_lable: selected_unit_number,
    });
  }

  handleChangePaymentStatusList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedPaymentStatusList: value,
      pay_status_slug: unit_slug_value,
      pay_status_lable: selected_unit_number,
    });
  }

  handleChangeMethodList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedMethodList: value,
      method_slug: unit_slug_value,
      method_lable: selected_unit_number,
    });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  getResponsivePlacement = (ref) => {
    if (!ref.current) return "bottom-start";

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const CALENDAR_HEIGHT_ESTIMATE = 330;
    const CALENDAR_WIDTH_ESTIMATE = 300;

    if (spaceBelow >= CALENDAR_HEIGHT_ESTIMATE || window.innerWidth <= 767) {
      return "bottom-start";
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= CALENDAR_WIDTH_ESTIMATE) return "right-start";
    if (spaceLeft >= CALENDAR_WIDTH_ESTIMATE) return "left-start";
    return spaceRight >= spaceLeft ? "right-start" : "left-start";
  };

  checkPayoutDatePlacement = () => {
    this.setState({
      payoutDatePlacement: this.getResponsivePlacement(this.payoutDateInputGroupRef),
    });
  };

  changeHandler = async (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    await this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  async filterData() {
    let comma = ",";
    let payoutDate = this.state.payout_date
      ? Moment(this.state.payout_date).format("YYYY-MM-DD")
      : "";
    let queryString =
      "unit_slug=" +
      (this.state.unit_slug ? this.state.unit_slug : "") +
      (this.state.type === undefined
        ? "&type_slug=" + (this.state.type_slug ? this.state.type_slug : "")
        : "") +
      "&payout_date=" +
      payoutDate +
      "&amount=" +
      this.state.amount +
      "&description=" +
      this.state.search_description +
      "&destination=" +
      this.state.destination +
      "&is_search=1";
    let moduleSearchString = "";
    let searchDisplay = "";
    if (this.state.unit_lable) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Unit: " +
        this.state.unit_lable;
    }
    if (this.state.type_label) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Type: " +
        this.state.type_label;
    }
    if (this.state.status_lable) {
      searchDisplay =
        searchDisplay + " Stripe Status: " + this.state.status_lable;
    }
    if (this.state.payout_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Date: " +
        Moment(payoutDate).format("MM/DD/YY");
    }
    if (this.state.amount) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Amount: " +
        this.state.amount;
    }
    if (this.state.search_description) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Description: " +
        this.state.search_description;
    }
    if (this.state.destination) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Destination: " +
        this.state.destination;
    }
    if (
      this.state.payout_date ||
      this.state.amount ||
      this.state.search_description ||
      this.state.destination ||
      this.state.status_lable ||
      this.state.unit_lable ||
      this.state.type_label ||
      this.state.type_slug ||
      this.state.unit_slug
    ) {
      this.setState({ customQueryString: queryString });
      this.searchToggle();
      this.setState({ is_search: 1 });
      this.setState({ module_search: moduleSearchString });
      this.setState({ module_search_display: searchDisplay.split(",") });
      this.getstripepayout(queryString);
    }
  }

  /* table events */
  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getstripepayout(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getstripepayout(queryString);
    }
  };

  rowClickedHandler = (event, data, rowIndex) => {
    window.open(
      this.props.match.params.propertySlug !== undefined
        ? "/properties/view/" +
            data.property_slug +
            (data.type === 2
              ? "/view-payout-property/"
              : "/view-payout-resident/") +
            data.summary_slug
        : (data.type === 2
            ? "/view-payout-property/"
            : "/view-payout-resident/") +
            data.property_slug +
            "/" +
            data.summary_slug,
      "_self"
    );
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    {this.props.match.params.propertySlug !== undefined ? (
                      <PayoutSidebar property_slug={this.state.property_slug} />
                    ) : (
                      <AllPropertyPayoutSidebar
                        property_slug={this.state.property_slug}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-10 right">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>Transfers</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        <button
                          className="btn-success-outline-small button-width"
                          onClick={this.searchToggle}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-lg-l-0 pd-lg-r-15 pd-xs-r-0">
                    {this.props.match.params.propertySlug === undefined ? (
                      <>
                        <div className="row pd-lg-l-15 pd-xs-l-0">
                          <div className="col-xxl-2 col-sm-3 pd-lg-r-0 pd-xs-r-15 pd-lg-l-45 pd-xs-l-15">
                            <OutSidePropertySelectBox
                              propertySlug={this.getPropertySlug.bind(this)}
                            />
                          </div>
                          <div className="col-xxl-10 col-md-9 col-sm-8 pd-r-15 pd-l-15">
                            {this.state.is_search === 1 ? (
                              <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                                <div className="custm-filter">
                                  <div>
                                    {" "}
                                    <label className="form-label text-left pd-b-2 mb-0">
                                      Search Applied On
                                    </label>
                                  </div>
                                  <div className="filter_bg_cust">
                                    {this.state.module_search_display.map(
                                      (item, i) => {
                                        return <span key={i}>{item}</span>;
                                      }
                                    )}
                                    <button
                                      onClick={this.clearFilter}
                                      className="btn-fliter-clear"
                                    >
                                      Clear
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="scrolling-carousel pd-l-15 scroll-slide">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="all"
                        onSelect={(e) => this.getActiveClass(e)}
                        eventKey={this.state.activeClass}
                        className="pd-r-60"
                      >
                        <Tab.Content className="m-0">
                          <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                            <div className="mg-t-18 brandList pd-l-15 pd-r-15 Report_table earning-report-tbl ">
                              <div className=" pd-lg-l-0 pd-xs-l-0">
                                <div className="scroll-report-table">
                                  <ReactDatatable
                                    className="table no-wrap mg-b-30 pd-b-2  brandtable border earning_reports resident-payout-table "
                                    config={
                                      this.state.total_record > global.page_size
                                        ? this.state.config
                                        : this.state.config
                                    }
                                    records={this.state.records}
                                    columns={this.state.columns}
                                    extraButtons={this.state.extraButtons}
                                    dynamic={true}
                                    total_record={this.state.total_record}
                                    onChange={this.tableChangeHandler}
                                    onRowClicked={this.rowClickedHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Module search popup modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Search in Transfers</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Unit</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedUnitList}
                      options={this.state.newUnitList}
                      onChange={(value) => this.handleChangeUnitList(value)}
                      defaultValue={this.state.selectedUnitList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Destination</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      onChange={(e) => this.onChangeSearchDestination(e)}
                      name="destination"
                      value={this.state.destination}
                      className="form-control max_width_100"
                      type="text"
                      maxLength="50"
                      autoComplete="off"
                      placeholder="Destination"
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3" ref={this.payoutDateInputGroupRef}>
                  <label>Payment Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="payout_date"
                    selected={this.state.payout_date}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "payout_date",
                          value: data,
                        },
                      })
                    }
                    popperPlacement={this.state.payoutDatePlacement}
                    onCalendarOpen={this.checkPayoutDatePlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Amount</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      onChange={(e) => this.onChangeSearchAmount(e)}
                      name="amount"
                      value={this.state.amount}
                      className="form-control max_width_100"
                      type="text"
                      maxLength="50"
                      autoComplete="off"
                      placeholder="Amount"
                    />
                  </div>
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Description</label>
                  <Form.Control
                    className="form-control max_width_100"
                    autoComplete="off"
                    type="text"
                    name="search_description"
                    placeholder="Description"
                    onChange={(e) => this.onChangeSearchDescription(e)}
                  />
                </InputGroup>
                {this.state.type === undefined ? (
                  <InputGroup className="mt-3">
                    <label>Type</label>
                    <div className="col-md-12 p-0">
                      <Select
                        styles={customStyles}
                        isClearable={true}
                        className="multiselect"
                        classNamePrefix={"my-custom-react-select"}
                        menuPlacement="auto"
                        value={this.state.selectedTypeList}
                        options={this.state.newTypeList}
                        onChange={(value) => this.handleChangeTypeList(value)}
                        defaultValue={this.state.selectedTypeList}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 2,
                          colors: {
                            ...theme.colors,
                            primary: "#fff",
                            primary75: "#000",
                            primary50: "#000",
                            primary25: "#000",
                          },
                        })}
                      />
                    </div>
                  </InputGroup>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.filterData()}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Module total bill popup modal */}
        <Modal show={this.state.is_total} className=" searchModalbox1" centered>
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span className="welcomeClose" onClick={() => this.totalbill()}>
              {global.closee}
            </span>
            <h3 className="text-center">
              Are you sure you want to payment payout
            </h3>

            <span className="d-flex justify-content-between align-items-center ">
              Total bill : ${this.state.totalBill ?? 0}
            </span>
            <span className="d-flex justify-content-between align-items-center ">
              Stripe Balance: ${this.state.Stripebalance ?? 0}
            </span>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.paymentpayout()}
              >
                Submit
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default StripeTotalPayout;
